// Per-type program-cap inputs (SLICE-PASS-TYPES). One number per pass type:
// blank = unlimited, 0 = not allowed, N = at most N programs of that type.
// Used by the tenant edit drawer (inside an override toggle) and the Plan Tiers
// editor (as the tier default). Keys track PASS_TYPES.

import { PASS_TYPES, type PassType, type ProgramCaps } from '@naya/shared'

const PASS_TYPE_LABEL: Record<PassType, string> = {
  loyalty: 'Loyalty (stamp card)',
  membership: 'Membership / VIP',
  event_ticket: 'Event ticket',
}

interface Props {
  value: ProgramCaps
  onChange: (caps: ProgramCaps) => void
  idPrefix: string
}

export function ProgramCapsFields({ value, onChange, idPrefix }: Props) {
  return (
    <>
      {PASS_TYPES.map((pt) => {
        const cap = value[pt]
        return (
          <div key={pt} className="admin-field" style={{ marginBottom: 8 }}>
            <label className="admin-label" htmlFor={`${idPrefix}-${pt}`}>
              {PASS_TYPE_LABEL[pt]}
            </label>
            <input
              id={`${idPrefix}-${pt}`}
              className="admin-input"
              type="number"
              min={0}
              max={1000}
              placeholder="Unlimited"
              value={cap === null || cap === undefined ? '' : String(cap)}
              onChange={(e) => {
                const raw = e.target.value.trim()
                onChange({ ...value, [pt]: raw === '' ? null : Number(raw) })
              }}
            />
          </div>
        )
      })}
      <p className="admin-hint">0 = not allowed · blank = unlimited.</p>
    </>
  )
}
